export const getEventStatus = (eventStatus?: string | null, caseStatus?: string | null): string => {
  const normalizedEventStatus = eventStatus?.toString().trim().toLowerCase();
  if (normalizedEventStatus) {
    return normalizedEventStatus;
  }

  const normalizedCaseStatus = caseStatus?.toString().trim().toLowerCase();
  return normalizedCaseStatus || 'pending';
};
